import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext } from 'react-admin'
import EditIcon from '@mui/icons-material/Edit'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import PhoneIcon from '@mui/icons-material/Phone'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { AirScaleRow } from 'src/components/pages/sales/reservation/logic/air/AirScaleRow'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { blue } from 'src/assets/colors'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { getAirports } from 'src/components/pages/sales/reservation/logic/air/AirScaleRow'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { PricingAirModal } from 'src/components/pages/sales/reservation/logic/modals/PricingAirModal'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { AirForm } from 'src/components/pages/sales/reservation/logic/air/AirForm'
import { guaranteeItemReservation } from 'src/components/pages/sales/reservation/helper/guaranteeItemReservation'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import { Comment } from '@mui/icons-material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import dayjs from 'dayjs'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { INVOICED } from '../common/state'
import { AIR_DETAIL } from 'src/helper/resourceEntity'
import { retriveItemReservation } from 'src/components/pages/sales/reservation/helper/retriveItemReservation'
import { voidItemReservation } from 'src/components/pages/sales/reservation/helper/voidItemReservation'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'

import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { approveRefuseFraudItemReservation } from '../../helper/approveRefuseFraudItemReservation'
import { registerReturn } from '../../helper/registerReturn'
import { ExchangeType } from '../common/ExchangeType'
import { EditOriginValues } from '../common/EditOriginValues'
import {CommentsCardComponent} from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

const SupplierAir = () => {
  const flight = useRecordContext()
  const translate = useTranslate()

  const getSupplier = () => {
    return flight.supplier_relation?.name || flight?.airline || ''
  }

  return <ShowElement data={getSupplier()} label={translate('ra.field.provider')} />
}

const PassengerAir = ({ reservation }) => {
  const flight = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = flight?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextAir = ({ reservation }) => {
  const air = useRecordContext()

  air?.segments?.[0]?.itineraryGroup?.forEach((elem) => {
    const departureDate =
      elem.departureDate && elem.departureTime ? dayjs(`${elem.departureDate} ${elem.departureTime}`) : null
    const arrivalDate =
      elem.arrivalDate && elem.arrivalTime ? dayjs(`${elem.arrivalDate} ${elem.arrivalTime}`) : null
    const timeMin = departureDate && arrivalDate ? arrivalDate.diff(departureDate, 'minute') : null
    const hours = timeMin ? Math.floor(timeMin / 60) : null
    const minutes = timeMin ? timeMin - hours * 60 : null
    elem.totalDuration = hours !== null && minutes !== null ? `${hours} hora(s) ${minutes} minuto(s)` : null
  })

  if (air) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <AirScaleRow air={air} />
        <Passenger
          itemId={air.item_id}
          passengers={air?.pax_relation}
          idResource={reservation?.id}
          hashItemReserve={air?.hash_}
          resource={AIR_DETAIL}
          status={air?.status}
        />
      </>
    )
  }
}

const ContextAirForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const air = useRecordContext()
  if (air && openProductModal) {
    return (
      <AirForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={air}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={air}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const FilesCard = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={air} />
      </ShowCard>
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)

  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }

  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }
  
  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation&& translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler')&& enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail')&& enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const IsCabotage = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.is_cabotage !== null && air?.is_cabotage !== undefined) {
    return <ShowElement data={air?.is_cabotage} label={translate('ra.field.cabotage')} boolean />
  }
}

const HasMetaCode = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.url_meta !== null && air?.url_meta !== undefined) {
    return (
      <ShowElement data={air?.url_meta} label={translate('ra.field.meta_code')} />
    )
  }
}

const HasFareCode = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.fare_code !== null && air?.fare_code !== undefined) {
    return <ShowElement data={air?.fare_code} label={translate('ra.field.fare_code')} />
  }
}

export const AirProduct = ({ reservation, air, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)
  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)
  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)
  // const [exchangeMode, setExchangeMode] = useState(false)
  const [openProductModal, setOpenProductModal] = useState(false)

  const [confirmEmit, setConfirmEmit] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)
  const [wasEmitted, setWasEmitted] = useState({})

  const [openRetriveModal, setOpenRetriveModal] = useState(false)
  const [loadingRetriveItem, setLoadingRetriveItem] = useState(false)
  const [confirmRetrive, setConfirmRetrive] = useState(false)

  const [confirmVoid, setConfirmVoid] = useState(false)
  const [openVoidModal, setOpenVoidModal] = useState(false)
  const [loadingVoidItem, setLoadingVoidItem] = useState(false)
  
  const [openFraudModal, setOpenFraudModal] = useState(false)
  const [confirmFraud, setConfirmFraud] = useState(false)
  const [approveFraud, setApproveFraud] = useState(false)
  const [loadingFraudItem, setLoadingFraudItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()
  const { setOpenDueDateModal } = useReservationInfo()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [changeStatusDialog, setChangeStatusDialog] = useState(false)

  const [isBillable, setIsBillable] = useState(air[0].is_billable)

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  const { setCardLoading } = useCardLoading()

  useEffect(()=>{
    const items = reservation.items
    const foundItem = items.find(item=>item.id === air[0].id)
    setIsBillable(foundItem.is_billable)
  },[reservation])

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmRegisterReturn) {
      registerReturn({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRegisterReturnItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmRegisterReturn,
        setOpenRegisterReturnModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
      if (changePostVentaStatus) {
        PostVentaStatus({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingPostventaStatus,
          setNameReserve,
          setHashItemReserve,
          setChangePostventaStatus,
          actualStatus
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changePostVentaStatus])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (confirmRetrive) {
      retriveItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingRetriveItem,
        setNameReserve,
        setConfirmRetrive,
        setOpenRetriveModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRetrive])

  useEffect(() => {
    if (confirmVoid) {
      voidItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingVoidItem,
        setNameReserve,
        setConfirmVoid,
        setOpenVoidModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmVoid])
  
  useEffect(() => {
    if (confirmFraud) {
      approveRefuseFraudItemReservation({
        hashItemReserve,
        approveFraud,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingFraudItem,
        setConfirmFraud,
        setOpenFraudModal
      })
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmFraud])

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)
    if (air && Array.isArray(air) && air.length > 0 && wasEmittedKeys.length > 0) {
      wasEmittedKeys.forEach((emit) => {
        const isEmmited = air.find((elem) => elem?.hash_ === emit && elem?.status === INVOICED)
        if (wasEmitted[emit] && isEmmited) {
          setWasEmitted((prev) => ({
            ...prev,
            [emit]: false,
          }))
          setLoadingEmitItem(false)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [air, wasEmitted])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      setOpenMoveModal(false)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }

  const getLabel = (product) => {
    try {
      if (product?.id_detail) {
        const label = getAirports(product?.segments?.[0]?.itineraryGroup)
        if (label) {
          return label
        }
      }
      return 'ERROR'
    } catch (error) {
      return 'ERROR'
    }
  }

  const onChangeBillable = async () =>{
    const newValue = !isBillable
    setIsBillable(newValue)
    await reservationServices.updateIsBillableProduct(air[0].hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    })
  }

  if (air) {
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingDeleteItem || loadingRetriveItem || loadingVoidItem}>
          <CircularProgress color='inherit' />
        </Backdrop>

        <TabProduct
          products={air}
          labelGetter={(product) => getLabel(product)}
          getStyle={(product) => (getLabel(product) == 'ERROR' ? { color: 'red' } : null)}
        >
          {!editMode && (
            <ToolbarReservation
              resource='air-detail'
              reservation={reservation}
              loadingCancel={loadingCancelItem}
              onCancel={(air) => {
                setOpen(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              onDeleted={(air) => {
                setOpenDeleteModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(air) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onMove={(air) => {
                setOpenMoveModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingMoveItem={loadingMoveItem}
              onClone={(air) => {
                setOpenCloneModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingCloneItem={loadingCloneItem}
              onEmit={(air) => {
                setOpenEmitModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingEmitItem={loadingEmitItem}
              onRetrive={(air) => {
                setOpenRetriveModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              onVoid={(air) => {
                setOpenVoidModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(air)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (air)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(air?.hash_)
                  setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(air)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(air?.hash_)
                setActualStatus(air.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextAirForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                              <ShowElement source='status' label={translate('ra.field.status')} />
                              <HasPermission resource={'item'} permission='edit_status'>
                                <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                              </HasPermission>
                            </div>
                            <ShowElement
                              source='created_at'
                              label={translate('ra.field.created_at')}
                              dateTime
                            />
                            <ShowElement
                              source='source_relation.short_name'
                              label={translate('ra.field.source')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'payment_status'}
                              label={translate('ra.field.payment_status')}
                              status
                              loading={loadingFraudItem}
                              onSelectOption={(train_segment, option) => {
                                setOpenFraudModal(true)
                                setHashItemReserve(train_segment?.hash_)
                                setApproveFraud(option === 'approve')
                              }}
                            />
                            <PassengerAir reservation={reservation} />
                            <BillingStatusField />
                            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                              <Box style={{padding: '5px 0px 5px 0px'}}>
                                <Typography
                                    variant='h7'
                                    component='span'
                                    style={{
                                      padding: '0px 5px 0px 5px',
                                      fontWeight: 600,
                                      flex: 1,
                                      maxWidth: 'fit-content'
                                    }}
                                  >
                                  {translate('ra.field.is_billable')}
                                  <Checkbox checked={isBillable} onChange={onChangeBillable}/>
                                </Typography>
                              </Box>
                            )}
                            <BillingAutomaticField />
                          </RigthSideCard>
                        </Box>
                        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                          {translate('ra.title.provider_info')}
                        </Typography>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <SupplierAir />
                            <ShowElement
                              source='pricing_relation.[0].currency_origin'
                              label={translate('ra.field.currency')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement source={'pnr_code'} label={translate('ra.field.provider_code')} />
                          </RigthSideCard>
                        </Box>
                      </CompleteSideCard>
                    </ShowCard>
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRetriveModal}
                      setConfirm={setConfirmRetrive}
                      open={openRetriveModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_void_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenVoidModal}
                      setConfirm={setConfirmVoid}
                      open={openVoidModal}
                    />
                    <ConfirmationDialog
                      title={approveFraud ? translate('ra.message.approve_fraud') : translate('ra.message.refuse_fraud')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenFraudModal}
                      setConfirm={setConfirmFraud}
                      open={openFraudModal}
                    />
                    <ChangeStatusDialog
                      open={changeStatusDialog}
                      setOpen={setChangeStatusDialog}
                      refresh={refresh}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>

                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <Button variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      iconHeader={<AirplanemodeActiveIcon />}
                      title={translate('ra.title.aerial_information')}
                    >
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement source='airline' label={translate('ra.field.airline')} />
                            <ShowElement source='gds' label={translate('ra.field.gds')} />
                            <ShowElement source='pnr_code' label={translate('ra.field.pnr')} />
                            <IsCabotage />
                            <HasMetaCode />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement source='type' label={translate('ra.field.type')} />
                            <ShowElement source='office' label={translate('ra.field.id_issue_office')} />´
                            <HasFareCode />
                          </RigthSideCard>
                        </Box>
                        <ContextAir reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <CommentsCardComponent itemId={air[0]?.item_id}/>
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    optionHeigth={'pricing'}
                    actionButtonIcon={<EditIcon />}
                    variant='text'
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingAirModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                      <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                        <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                          <HasPermission permission='hasEdit' resource={'pricing'}>
                              <Button
                              onClick={()=>{setHistoryCostsDialog(true)}}
                              sx={{ paddingX: '10px', marginX:'5px' }}
                              size='small'
                              variant='contained'
                              >
                              {translate('ra.title.price_history')}
                              </Button>
                          </HasPermission>
                        </Box>
                        <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal} />
                      </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
